import { render } from "./ConfiguracionParametros.vue?vue&type=template&id=4586d6c0&scoped=true"
import script from "./ConfiguracionParametros.vue?vue&type=script&lang=js"
export * from "./ConfiguracionParametros.vue?vue&type=script&lang=js"

import "./ConfiguracionParametros.vue?vue&type=style&index=0&id=4586d6c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4586d6c0"]])

export default __exports__